module.exports = __webpack_public_path__ + "img/first4.f62f0388.png";